export const appConfig = {
    common: {
        appName: process.env.VUE_APP_APP_NAME,
        appVersion: process.env.VUE_APP_VERSION,
        appUri: process.env.VUE_APP_URI,
        rowsPerPageItems: [10, 20, 50],
        tooltipDelay: 600,
        attachmentSize: 20,
        processes: {
            ctpTaskId: 71,
            printTaskId: 43,
            dieCuttingTaskId: 36,
            cleaningAfterDieCuttingTaskId: 100,
            folderGluerTaskId: 131,
            cuttingPaperTaskId: 68,
            slicingAfterPrintingTaskId: 37,
            slicingAfterFinishingTaskId: 66,
            laminationTaskId: 51,
            packingTaskId: 44,
            sendingTaskId: 45,
            finishingTaskId: 34,
            cooperationTaskId: 52,
            foldingTaskId: 46,
        },
        defaultColorUsedPercents: {
            basic: 25, // zwyczajny
            pms: 70, // Pantone
            lacquer : 100, // Lakiery
        },
        defaultMaterialUsedPercents: {
            uv: 50 // UV
        },
        schedulerLicenseKey: '0993436951-fcs-1657372933'
    },
    dashboards: {
        rowsPerPageItems: [8, 16, 24],
    },
    complaints: {
        complaintAttachmentSize: 20
    },
    reports: {
        workerTimeFilter: 12,
        rowsPerPageItems: [5, 15, 30],
        diagramColors: [
            'rgb(255, 99, 132)',
            'rgb(54, 162, 235)',
            'rgb(255, 205, 86)',
            'rgb(133, 86, 255)',
            'rgb(167, 224, 141)',
            'rgb(99, 255, 180)',
            'rgb(255, 191, 99)',
        ],
        generalGroups: ['introligatornia', 'spedycja'],
        reportTypes: ['godzinowy', 'zmianowy']
    },
    productionSiteNotes: {
        rowsPerPageItems: [3, 8, 15]
    },
    orders: {
        parcelMaxCount: 13,
        parcelMinWeight: 0.01,
        parcelMaxWeight: 31.5,
        productionFileAttachmentSize: 250,
        productionFileAttachmentSizeProof: 25,
    },
    jobs: {
        orderComponents: {
            rowsPerPageItems: [30, 50, 100],
        },
        maxWastePercent: 25
    },
    labels: {
        maxPackagesPerLabel: 100,
        revisoryLabelObjects: [
            {
                type: 'KP',
                verboseName: 'zamówienie'
            },
            {
                type: 'KZ',
                verboseName: 'zlecenie'
            },

        ]
    },
    sendings: {
        permissionsPin: 6194,
        boxMaxCount: 13
    },
    configurations: {
        productProperties: {
            productionPropertiesMaxCount: 6
        },
        machines: {
            numberOfWorkersMaxCount: 9
        },
        tools: {
            dieCutters: {
                attachmentSize: 30
            }
        },
        materials: {
            attachmentSize: 250
        },
    },
    shipping: {
        notification: {
            minTime: '00:00',
            maxTime: '24:00',
            slotDurationNotification: '00:30:00',
            slotDurationDispatch: '00:15:00',
            slotDurationGateHouse: '00:15:00'
        },
        shippingOrders: {
            headquartersContactId: 466 // Id klienta 'Colours Factory'
        },
        carrierPalletTransport: 'CF - paleta kurier'
    },
    outdoors: {
        map: {
            apiKey: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
            mapId: 'fac3c13ad9241fbe',
            defaultLatitude: 52.08,
            defaultLongitude: 19.145136,
            countryBounds: {
                southWestLat: '49.002025',
                southWestLng: '14.122864',
                northEastLat: '54.835812',
                northEastLng: '24.145893'
            },
            zoom: 18,
            markerClusterer: {
                gridSize: 60,
                maxZoom: 9,
                styles: [
                    {
                        width: 25,
                        height: 25,
                        className: 'cluster-icon-1',
                    },
                    {
                        width: 35,
                        height: 35,
                        className: 'cluster-icon-2',
                    },
                    {
                        width: 45,
                        height: 45,
                        className: 'cluster-icon-3',
                    },
                ],
                clusterClass: 'cluster-icon',
            }
        }
    }

}

export const apiConfig = {
    FACTORYBASE_API_URI: process.env.VUE_APP_FACTORYBASE_API_URI,
    TIMEOUT: process.env.VUE_APP_API_TIMEOUT,
    MOCKUP_API_URI: process.env.VUE_APP_MOCKUP_API_URI,
}
